import React, { useEffect, useState } from "react";
import Banner from "../components/Banner";
import CourseSidebar from "../components/course/CourseSidebar";
import CourseContent from "../components/course/CourseContent";
import { useParams } from "react-router-dom";
import {
  IAcademicsMenuCoursesData,
  IAcademicsMenuProgramsData,
} from "../exports/interfaces";
import {
  fetchAcademicsMenuCourses,
  fetchAcademicsMenuPrograms,
} from "../api/HomeApi";
import { dynamicFailed } from "../hooks/custom/useToast";
import { useLoader } from "../context/LoaderContext";
import { useMobile } from "../hooks/custom/useMobile";
import useTab from "../hooks/custom/useTab";

const CoursePage = () => {
  const { program, course } = useParams();
  const { setLoading } = useLoader();
  const mobile = useMobile();
  const tab = useTab();
  const [openSidebar, setOpenSidebar] = useState(false);
  const [academicsMenuPrograms, setAcademicsMenuPrograms] = useState<
    IAcademicsMenuProgramsData[]
  >([]);
  const [academicsMenuCourses, setAcademicsMenuCourses] = useState<
    IAcademicsMenuCoursesData[]
  >([]);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchAcademicsMenuPrograms(), fetchAcademicsMenuCourses()])
      .then(([academicsMenuProgramsData, AcademicsMenuCoursesData]) => {
        setAcademicsMenuPrograms(academicsMenuProgramsData);
        setAcademicsMenuCourses(AcademicsMenuCoursesData);
        setLoading(false);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
        setLoading(false);
      });
  }, [setLoading]);

  const programsDetails = academicsMenuPrograms.map((program) => {
    return {
      title: program.title,
      color: program.color_code,
      icon: program.icon_code,
      icon_image: program.icon_image,
      courses: academicsMenuCourses
        .filter((course) => course.program_name === program.title)
        .map((course) => ({
          ...course,
          start_background_color: program.start_background_color,
          end_background_color: program.end_background_color,
        })),
    };
  });

  const selectedCourse = programsDetails
    .flatMap((program) => program.courses)
    .find((item) => item.name === course);

  return (
    <>
      <Banner
        title="Academics"
        bannerImage={selectedCourse?.banner_image[0]}
        start_background_color={selectedCourse?.start_background_color}
        end_background_color={selectedCourse?.end_background_color}
        program={program || ""}
        course={course || ""}
      />
      <section id="introduction">
        <div className="td_height_120 td_height_lg_40" />
        <div className="td_about td_style_1">
          <div className="container">
            {(mobile || tab) && (
              <div className="course_sidebar_toggle_wrapper td_mb_20">
                <h3 className="mb-0">Academic Programs</h3>
                <button
                  className="course_sidebar_toggle mt-1"
                  onClick={() => setOpenSidebar(true)}
                >
                  <span></span>
                  <span></span>
                  <span></span>
                  {/* <span></span>
                  <span></span>
                  <span></span> */}
                </button>
              </div>
            )}
            <div className="row td_gap_y_40 td_mb_40">
              <CourseSidebar
                programsDetails={programsDetails}
                program={program || ""}
                course={course || ""}
                openSidebar={openSidebar}
                setOpenSidebar={setOpenSidebar}
              />
              <CourseContent
                // program={program || ""}
                // course={course || ""}
                selectedCourse={selectedCourse || null}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CoursePage;
